export enum WatermarkRulePosition {
    TopRight = 1,
    BottomRight = 2
}
